import { MonarchKeyboardShortcutsMode } from "owa-outlook-service-option-store";
import type WebKeyboardShortcutsMode from "owa-service/lib/contract/KeyboardShortcutsMode";
import getKeyboardShortcutsMode from "./getKeyboardShortcutsMode";
import shouldUseMonarchShortcuts from "./shouldUseMonarchShortcuts";

export default function shouldUseOutlookKeyboardShortcuts(): boolean {
    const keyboardShortcutsMode = getKeyboardShortcutsMode();
    
    return shouldUseMonarchShortcuts()
        ? keyboardShortcutsMode === MonarchKeyboardShortcutsMode.OutlookForWindows ||
            keyboardShortcutsMode === MonarchKeyboardShortcutsMode.OutlookForWeb
        : keyboardShortcutsMode === 4;
}
